import type { ReactNode } from 'react';

interface Props {
  label: string;
  children: ReactNode;
}

/** A labelled block inside a profile editor — the modal's stacked answer to StepField. */
export default function ModalField({ label, children }: Props) {
  return (
    <div className="flex flex-col gap-ds-lg">
      <p className="typography-product-subheading text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {label}
      </p>
      {children}
    </div>
  );
}
